module.exports = __webpack_public_path__ + "static/media/pic_selfie.5d57f214.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/pic_selfie.jpg
// module id = 362
// module chunks = 0